export enum InputType {
  Info = "info",
  QuestionSet = "field_set",
  Question = "field",
  Action = "action",
  Workflow = "workflow",
  // item
  // variable
}
